module.exports = __webpack_public_path__ + "img/结算台.3b3e2775.png";